import { render } from "./SimpleButton.vue?vue&type=template&id=8a94f940&scoped=true"
import script from "./SimpleButton.vue?vue&type=script&lang=js"
export * from "./SimpleButton.vue?vue&type=script&lang=js"

import "./SimpleButton.vue?vue&type=style&index=0&id=8a94f940&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a94f940"]])

export default __exports__